import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";
import { getActiveProjects, getIskoopProjects } from "../../api/projectsService";
// ❌ KALDIRILDI: import { getProjectsByCategory } from "../../components/Projects/projectsData";
import { FaTools, FaCheckCircle, FaHourglassHalf } from "react-icons/fa";
registerLocale("tr", tr);

const DEFAULT_IMAGE = "/assets/images/example-post.jpg";

export default function Projects() {
  const brandPrimary = "#084977";

  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCategory, setActiveCategory] = useState("genel");
  const [iskoopProjects, setIskoopProjects] = useState([]);

  useEffect(() => { fetchProjects(); }, [searchTerm, activeCategory]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      setError(null);

      if (activeCategory === "iskoop") {
        const res = await getIskoopProjects(1, 1000, searchTerm);
        if (res?.isSuccess && res?.data) {
          setIskoopProjects(res.data.items || []);
          setData([]);
        } else {
          setError("İSKOOP projeleri yüklenirken bir hata oluştu");
          setIskoopProjects([]);
        }
      } else {
        const res = await getActiveProjects(1, 1000, searchTerm, "genel");
        if (res?.isSuccess && res?.data) {
          setData(res.data.items || []);
          setIskoopProjects([]);
        } else {
          setError("Projeler yüklenirken bir hata oluştu");
          setData([]);
        }
      }

    } catch (e) {
      console.error(e);
      setError("Projeler yüklenirken bir hata oluştu");
      setData([]);
      setIskoopProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => setSearchTerm(e.target.value);
  const handleImageError = (e) => { e.target.src = DEFAULT_IMAGE; };

  const activeData = useMemo(() => {
    return activeCategory === "iskoop" ? iskoopProjects : data;
  }, [activeCategory, data, iskoopProjects]);

  const ongoing = useMemo(
    () => activeData.filter(p => (p?.status || "").toLowerCase().includes("devam")),
    [activeData]
  );
  const done = useMemo(
    () => activeData.filter(p => !(p?.status || "").toLowerCase().includes("devam")),
    [activeData]
  );

  const CategoryButtons = () => (
    <div className="category-buttons" style={{
      display: "flex",
      gap: "12px",
      marginBottom: "20px",
      alignItems: "center"
    }}>
      <button
        className={`category-btn ${activeCategory === "genel" ? "active" : ""}`}
        onClick={() => setActiveCategory("genel")}
        style={{
          padding: "8px 16px",
          width: "132px",
          height: "62px",
          border: "2px solid #ddd",
          borderRadius: "25px",
          background: activeCategory === "genel" ? brandPrimary : "#fff",
          color: activeCategory === "genel" ? "#fff" : "#333",
          cursor: "pointer",
          fontWeight: "500",
          transition: "all 0.3s ease"
        }}
      >
        Genel
      </button>
      <button
        className={`category-btn iskoop-btn ${activeCategory === "iskoop" ? "active" : ""}`}
        onClick={() => setActiveCategory("iskoop")}
        style={{
          padding: "8px 16px",
          border: "2px solid #ddd",
          borderRadius: "25px",
          background: activeCategory === "iskoop" ? brandPrimary : "#fff",
          color: activeCategory === "iskoop" ? "#fff" : "#333",
          cursor: "pointer",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          transition: "all 0.3s ease"
        }}
      >
        <img
          src="/assets/images/iskooplogotransparent.png"
          alt="İSKOOP Logo"
          style={{ width: "104px", height: "44px", objectFit: "contain" }}
        />
      </button>
    </div>
  );

  return (
    <div className="news-page page-projects">

      <div className="news-tabs">
        <div className="container">
          <div className="news-title">
            <h1>Projelerimiz</h1>
          </div>
          <div className="news-tabs-filter">
            <div className="news-tabs-filter-left">
              <div className="news-tabs-filter-left-item">
                <input
                  type="text"
                  placeholder="Projelerde Ara"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <i className="pi pi-search"></i>
              </div>
            </div>
          </div>

          <div className="news-tabs-content">
            {loading ? (
              <div className="loading">Yükleniyor...</div>
            ) : error ? (
              <div className="alert alert-warning" role="alert">{error}</div>
            ) : (done.length + ongoing.length) === 0 ? (
              <div className="text-center py-5"><p>Proje bulunamadı.</p></div>
            ) : (
              <>
                <section className="projects-section done-section" style={{ marginBottom: 28 }}>
                  <header style={{ display: "flex", alignItems: "baseline", gap: 12, margin: "6px 0 14px" }}>
                    <h2 style={{ margin: 0 }}>Hizmete Açılan Projeler</h2>
                    <span style={{ color: "#6b7280" }}>({done.length})</span>
                  </header>
                  <CategoryButtons />
                  {done.length === 0 ? (
                    <div className="text-muted" style={{ padding: "8px 0 4px" }}>
                      Bu sayfada hizmete açılan proje bulunamadı.
                    </div>
                  ) : (
                    <div className="projects-grid">
                      {done.map((p, i) => (
                        <Link key={`${p.slug || p.id}-${i}`} to={`/projeler/${p.slug}`}>
                          <div className="project-card">
                            <div
                              className={`project-card-media ${p.fit === "contain" ? "is-contain" : "is-cover"}`}
                              style={p.bg ? { backgroundColor: p.bg } : undefined}
                            >
                              <img src={p.image || DEFAULT_IMAGE} alt={p.title} onError={handleImageError} />
                            </div>
                            <div className="project-card-body">
                              <h3 className="project-card-title">{p.title}</h3>
                              <p className="project-card-status status-green">
                                <FaCheckCircle style={{ marginRight: 6 }} />
                                {p.status || "Hizmete Açıldı"}
                              </p>
                              <p className="project-card-desc">{p.summary || p.description}</p>
                              <span className="project-card-btn">Detaya Git</span>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </section>

                <section className="projects-section ongoing-section">
                  <header style={{ display: "flex", alignItems: "baseline", gap: 12, margin: "6px 0 14px" }}>
                    <h2 style={{ margin: 0 }}>Devam Eden Projeler</h2>
                    <span style={{ color: "#6b7280" }}>({ongoing.length})</span>
                  </header>

                  {ongoing.length === 0 ? (
                    <div className="text-muted" style={{ padding: "8px 0 4px" }}>
                      Bu sayfada devam eden proje bulunamadı.
                    </div>
                  ) : (
                    <div className="projects-grid">
                      {ongoing.map((p, i) => (
                        <Link key={`${p.slug || p.id}-${i}`} to={`/projeler/${p.slug}`}>
                          <div className="project-card">
                            <div
                              className={`project-card-media ${p.fit === "contain" ? "is-contain" : "is-cover"}`}
                              style={p.bg ? { backgroundColor: p.bg } : undefined}
                            >
                              <img src={p.image || DEFAULT_IMAGE} alt={p.title} onError={handleImageError} />
                            </div>
                            <div className="project-card-body">
                              <h3 className="project-card-title">{p.title}</h3>
                              <p className="project-card-status status-yellow">
                                <FaHourglassHalf style={{ marginRight: 6 }} />
                                {p.status || "Devam Ediyor"}
                              </p>
                              <p className="project-card-desc">{p.summary || p.description}</p>
                              <span className="project-card-btn">Detaya Git</span>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </section>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
